// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Hc5Q","requiredAsterisk":"Info_requiredAsterisk__1S_Vl"};